

let hostName = window.location.host;
hostName = hostName.split('.');

// export const apiUrl ="http://helpdesk.localhost/api/";
//  export const apiUrl ="http://127.0.0.1:8000/api/";

//  SalmanShahr and SorkhRoud and Shirood and Amirkola
 export const apiUrl = `https://deskadmin.${hostName[1]}.${hostName[2]}/api/`
// export const apiUrl ="https://deskadmin.amirkola.ir/api/";
// SorkhRoud for test
//  export const apiUrl =`https://deskadmin.sorkhroud.ir/api/`;
//  AbbasAbad and Amol and Royan
  // export const apiUrl =`https://desk.${hostName[1]}.${hostName[2]}/api/`;
// export const apiUrl ="https://desk.myamol.ir/api/";
// export const apiUrl ="http://enc-pc:8080/api/";
//  export const apiUrl ="https://desk.shahrdariabasabad.ir/api/";
//export const apiUrl ="https://deskadmin.mz-ict.ir/api/";
//export const apiUrl ="http://192.168.100.9/api/";







